import { render, staticRenderFns } from "./DashboardSidebarLogo.vue?vue&type=template&id=32a4b6f2&scoped=true"
import script from "./DashboardSidebarLogo.vue?vue&type=script&lang=js"
export * from "./DashboardSidebarLogo.vue?vue&type=script&lang=js"
import style0 from "./DashboardSidebarLogo.vue?vue&type=style&index=0&id=32a4b6f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a4b6f2",
  null
  
)

export default component.exports